/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSoMe as ResolvedStandaloneSoMe } from 'base/components/standalone/SoMe';

export const SoMe: typeof ResolvedStandaloneSoMe = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSoMe {...props} />
        </ErrorBoundary>
    );
});

export type SoMeProps = PropsFromComponent<typeof SoMe>;

/** @deprecated Use slot architecture instead */
export const SoMeWith = (extras: DynamicStandaloneExtras): typeof SoMe => {
    return function SoMe(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SoMe');
        return <ResolvedStandaloneSoMe {...mergeProps({ options: { theme } }, props)} />;
    }
}